import _slicedToArray from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { __awaiter, __rest } from 'tslib';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import AntModal from 'antd/es/modal';
import AntUpload from 'antd/es/upload';
import { forwardRef, useState, useRef, useCallback, useImperativeHandle, memo, useMemo } from 'react';
import AntButton from 'antd/es/button';
import AntSlider from 'antd/es/slider';
import Cropper from 'react-easy-crop';
var PREFIX = 'img-crop';
var ZOOM_INITIAL = 1;
var ZOOM_STEP = 0.1;
var ROTATION_INITIAL = 0;
var ROTATION_MIN = -180;
var ROTATION_MAX = 180;
var ROTATION_STEP = 1;
var ASPECT_STEP = 0.01;
var EasyCrop = forwardRef(function (props, ref) {
  var cropperRef = props.cropperRef,
    zoomSlider = props.zoomSlider,
    rotationSlider = props.rotationSlider,
    aspectSlider = props.aspectSlider,
    showReset = props.showReset,
    resetBtnText = props.resetBtnText,
    modalImage = props.modalImage,
    ASPECT_INITIAL = props.aspect,
    minZoom = props.minZoom,
    maxZoom = props.maxZoom,
    minAspect = props.minAspect,
    maxAspect = props.maxAspect,
    cropShape = props.cropShape,
    showGrid = props.showGrid,
    cropperProps = props.cropperProps;
  var _useState = useState(ZOOM_INITIAL),
    _useState2 = _slicedToArray(_useState, 2),
    zoom = _useState2[0],
    setZoom = _useState2[1];
  var _useState3 = useState(ROTATION_INITIAL),
    _useState4 = _slicedToArray(_useState3, 2),
    rotation = _useState4[0],
    setRotation = _useState4[1];
  var _useState5 = useState(ASPECT_INITIAL),
    _useState6 = _slicedToArray(_useState5, 2),
    aspect = _useState6[0],
    setAspect = _useState6[1];
  var isResetActive = zoom !== ZOOM_INITIAL || rotation !== ROTATION_INITIAL || aspect !== ASPECT_INITIAL;
  var onReset = function onReset() {
    setZoom(ZOOM_INITIAL);
    setRotation(ROTATION_INITIAL);
    setAspect(ASPECT_INITIAL);
  };
  var _useState7 = useState({
      x: 0,
      y: 0
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    crop = _useState8[0],
    onCropChange = _useState8[1];
  var cropPixelsRef = useRef({
    width: 0,
    height: 0,
    x: 0,
    y: 0
  });
  var onCropComplete = useCallback(function (_, croppedAreaPixels) {
    cropPixelsRef.current = croppedAreaPixels;
  }, []);
  useImperativeHandle(ref, function () {
    return {
      rotation: rotation,
      cropPixelsRef: cropPixelsRef,
      onReset: onReset
    };
  });
  var wrapperClass = '[display:flex] [align-items:center] [width:60%] [margin-inline:auto]';
  var buttonClass = '[display:flex] [align-items:center] [justify-content:center] [height:32px] [width:32px] [background:transparent] [border:0] [font-family:inherit] [font-size:18px] [cursor:pointer] disabled:[opacity:20%] disabled:[cursor:default]';
  var sliderClass = '[flex:1]';
  return jsxs(Fragment, {
    children: [jsx(Cropper, Object.assign({}, cropperProps, {
      ref: cropperRef,
      image: modalImage,
      crop: crop,
      //
      zoom: zoom,
      rotation: rotation,
      aspect: aspect,
      minZoom: minZoom,
      maxZoom: maxZoom,
      zoomWithScroll: zoomSlider,
      //
      cropShape: cropShape,
      showGrid: showGrid,
      onCropChange: onCropChange,
      onZoomChange: setZoom,
      onRotationChange: setRotation,
      onCropComplete: onCropComplete,
      classes: {
        containerClassName: "".concat(PREFIX, "-container ![position:relative] [width:100%] [height:40vh] [&~section:first-of-type]:[margin-top:16px] [&~section:last-of-type]:[margin-bottom:16px]"),
        mediaClassName: "".concat(PREFIX, "-media")
      }
    })), zoomSlider && jsxs("section", {
      className: "".concat(PREFIX, "-control ").concat(PREFIX, "-control-zoom ").concat(wrapperClass),
      children: [jsx("button", {
        className: buttonClass,
        onClick: function onClick() {
          return setZoom(+(zoom - ZOOM_STEP).toFixed(1));
        },
        disabled: zoom - ZOOM_STEP < minZoom,
        children: "\uFF0D"
      }), jsx(AntSlider, {
        className: sliderClass,
        min: minZoom,
        max: maxZoom,
        step: ZOOM_STEP,
        value: zoom,
        onChange: setZoom
      }), jsx("button", {
        className: buttonClass,
        onClick: function onClick() {
          return setZoom(+(zoom + ZOOM_STEP).toFixed(1));
        },
        disabled: zoom + ZOOM_STEP > maxZoom,
        children: "\uFF0B"
      })]
    }), rotationSlider && jsxs("section", {
      className: "".concat(PREFIX, "-control ").concat(PREFIX, "-control-rotation ").concat(wrapperClass),
      children: [jsx("button", {
        className: "".concat(buttonClass, " [font-size:16px]"),
        onClick: function onClick() {
          return setRotation(rotation - ROTATION_STEP);
        },
        disabled: rotation === ROTATION_MIN,
        children: "\u21BA"
      }), jsx(AntSlider, {
        className: sliderClass,
        min: ROTATION_MIN,
        max: ROTATION_MAX,
        step: ROTATION_STEP,
        value: rotation,
        onChange: setRotation
      }), jsx("button", {
        className: "".concat(buttonClass, " [font-size:16px]"),
        onClick: function onClick() {
          return setRotation(rotation + ROTATION_STEP);
        },
        disabled: rotation === ROTATION_MAX,
        children: "\u21BB"
      })]
    }), aspectSlider && jsxs("section", {
      className: "".concat(PREFIX, "-control ").concat(PREFIX, "-control-aspect ").concat(wrapperClass),
      children: [jsx("button", {
        className: buttonClass,
        onClick: function onClick() {
          return setAspect(+(aspect - ASPECT_STEP).toFixed(2));
        },
        disabled: aspect - ASPECT_STEP < minAspect,
        children: "\u2195"
      }), jsx(AntSlider, {
        className: sliderClass,
        min: minAspect,
        max: maxAspect,
        step: ASPECT_STEP,
        value: aspect,
        onChange: setAspect
      }), jsx("button", {
        className: buttonClass,
        onClick: function onClick() {
          return setAspect(+(aspect + ASPECT_STEP).toFixed(2));
        },
        disabled: aspect + ASPECT_STEP > maxAspect,
        children: "\u2194"
      })]
    }), showReset && (zoomSlider || rotationSlider || aspectSlider) && jsx(AntButton, {
      className: "[bottom:20px] [position:absolute]",
      style: isResetActive ? {} : {
        opacity: 0.3,
        pointerEvents: 'none'
      },
      onClick: onReset,
      children: resetBtnText
    })]
  });
});
var EasyCrop$1 = memo(EasyCrop);
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z = ".\\[align-items\\:center\\]{align-items:center}.\\[background\\:transparent\\]{background:transparent}.\\[border\\:0\\]{border:0}.\\[bottom\\:20px\\]{bottom:20px}.\\[cursor\\:pointer\\]{cursor:pointer}.\\[display\\:flex\\]{display:flex}.\\[flex\\:1\\]{flex:1}.\\[font-family\\:inherit\\]{font-family:inherit}.\\[font-size\\:16px\\]{font-size:16px}.\\[font-size\\:18px\\]{font-size:18px}.\\[height\\:32px\\]{height:32px}.\\[height\\:40vh\\]{height:40vh}.\\[justify-content\\:center\\]{justify-content:center}.\\[margin-inline\\:auto\\]{margin-inline:auto}.\\[position\\:absolute\\]{position:absolute}.\\!\\[position\\:relative\\]{position:relative!important}.\\[width\\:100\\%\\]{width:100%}.\\[width\\:32px\\]{width:32px}.\\[width\\:60\\%\\]{width:60%}.disabled\\:\\[cursor\\:default\\]:disabled{cursor:default}.disabled\\:\\[opacity\\:20\\%\\]:disabled{opacity:20%}.\\[\\&\\~section\\:first-of-type\\]\\:\\[margin-top\\:16px\\]~section:first-of-type{margin-top:16px}.\\[\\&\\~section\\:last-of-type\\]\\:\\[margin-bottom\\:16px\\]~section:last-of-type{margin-bottom:16px}";
styleInject(css_248z, {
  "insertAt": "top"
});
var ImgCrop = forwardRef(function (props, cropperRef) {
  var _props$quality = props.quality,
    quality = _props$quality === void 0 ? 0.4 : _props$quality,
    _props$fillColor = props.fillColor,
    fillColor = _props$fillColor === void 0 ? 'white' : _props$fillColor,
    _props$zoomSlider = props.zoomSlider,
    zoomSlider = _props$zoomSlider === void 0 ? true : _props$zoomSlider,
    _props$rotationSlider = props.rotationSlider,
    rotationSlider = _props$rotationSlider === void 0 ? false : _props$rotationSlider,
    _props$aspectSlider = props.aspectSlider,
    aspectSlider = _props$aspectSlider === void 0 ? false : _props$aspectSlider,
    _props$showReset = props.showReset,
    showReset = _props$showReset === void 0 ? false : _props$showReset,
    resetText = props.resetText,
    _props$aspect = props.aspect,
    aspect = _props$aspect === void 0 ? 1 : _props$aspect,
    _props$minZoom = props.minZoom,
    minZoom = _props$minZoom === void 0 ? 1 : _props$minZoom,
    _props$maxZoom = props.maxZoom,
    maxZoom = _props$maxZoom === void 0 ? 3 : _props$maxZoom,
    _props$minAspect = props.minAspect,
    minAspect = _props$minAspect === void 0 ? 0.5 : _props$minAspect,
    _props$maxAspect = props.maxAspect,
    maxAspect = _props$maxAspect === void 0 ? 2 : _props$maxAspect,
    _props$cropShape = props.cropShape,
    cropShape = _props$cropShape === void 0 ? 'rect' : _props$cropShape,
    _props$showGrid = props.showGrid,
    showGrid = _props$showGrid === void 0 ? false : _props$showGrid,
    cropperProps = props.cropperProps,
    modalClassName = props.modalClassName,
    modalTitle = props.modalTitle,
    modalWidth = props.modalWidth,
    modalOk = props.modalOk,
    modalCancel = props.modalCancel,
    onModalOk = props.onModalOk,
    onModalCancel = props.onModalCancel,
    modalProps = props.modalProps,
    beforeCrop = props.beforeCrop,
    children = props.children;
  var cb = useRef({});
  cb.current.onModalOk = onModalOk;
  cb.current.onModalCancel = onModalCancel;
  cb.current.beforeCrop = beforeCrop;
  /**
   * crop
   */
  var easyCropRef = useRef(null);
  var getCropCanvas = useCallback(function (target) {
    var _a;
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var context = ((_a = target === null || target === void 0 ? void 0 : target.getRootNode) === null || _a === void 0 ? void 0 : _a.call(target)) || document;
    var imgSource = context.querySelector(".".concat(PREFIX, "-media"));
    var _easyCropRef$current$ = easyCropRef.current.cropPixelsRef.current,
      cropWidth = _easyCropRef$current$.width,
      cropHeight = _easyCropRef$current$.height,
      cropX = _easyCropRef$current$.x,
      cropY = _easyCropRef$current$.y;
    if (rotationSlider && easyCropRef.current.rotation !== ROTATION_INITIAL) {
      var imgWidth = imgSource.naturalWidth,
        imgHeight = imgSource.naturalHeight;
      var angle = easyCropRef.current.rotation * (Math.PI / 180);
      // get container for rotated image
      var sine = Math.abs(Math.sin(angle));
      var cosine = Math.abs(Math.cos(angle));
      var squareWidth = imgWidth * cosine + imgHeight * sine;
      var squareHeight = imgHeight * cosine + imgWidth * sine;
      canvas.width = squareWidth;
      canvas.height = squareHeight;
      ctx.fillStyle = fillColor;
      ctx.fillRect(0, 0, squareWidth, squareHeight);
      // rotate container
      var squareHalfWidth = squareWidth / 2;
      var squareHalfHeight = squareHeight / 2;
      ctx.translate(squareHalfWidth, squareHalfHeight);
      ctx.rotate(angle);
      ctx.translate(-squareHalfWidth, -squareHalfHeight);
      // draw rotated image
      var imgX = (squareWidth - imgWidth) / 2;
      var imgY = (squareHeight - imgHeight) / 2;
      ctx.drawImage(imgSource, 0, 0, imgWidth, imgHeight, imgX, imgY, imgWidth, imgHeight);
      // crop rotated image
      var imgData = ctx.getImageData(0, 0, squareWidth, squareHeight);
      canvas.width = cropWidth;
      canvas.height = cropHeight;
      ctx.putImageData(imgData, -cropX, -cropY);
    } else {
      canvas.width = cropWidth;
      canvas.height = cropHeight;
      ctx.fillStyle = fillColor;
      ctx.fillRect(0, 0, cropWidth, cropHeight);
      ctx.drawImage(imgSource, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
    }
    return canvas;
  }, [fillColor, rotationSlider]);
  /**
   * upload
   */
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    modalImage = _useState10[0],
    setModalImage = _useState10[1];
  var onCancel = useRef();
  var onOk = useRef();
  var runBeforeUpload = useCallback(function (_a) {
    return __awaiter(void 0, [_a], void 0, function (_ref) {
      var beforeUpload = _ref.beforeUpload,
        file = _ref.file,
        resolve = _ref.resolve,
        reject = _ref.reject;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var rawFile, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              rawFile = file;
              if (!(typeof beforeUpload !== 'function')) {
                _context.next = 4;
                break;
              }
              resolve(rawFile);
              return _context.abrupt("return");
            case 4:
              _context.prev = 4;
              _context.next = 7;
              return beforeUpload(file, [file]);
            case 7:
              result = _context.sent;
              if (result === false) {
                resolve(false);
              } else {
                resolve(result !== true && result || rawFile);
              }
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              reject(_context.t0);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4, 11]]);
      })();
    });
  }, []);
  var getNewBeforeUpload = useCallback(function (beforeUpload) {
    return function (file, fileList) {
      return new Promise(function (_resolve, _reject) {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
          var processedFile, result, reader;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                processedFile = file;
                if (!(typeof cb.current.beforeCrop === 'function')) {
                  _context4.next = 14;
                  break;
                }
                _context4.prev = 2;
                _context4.next = 5;
                return cb.current.beforeCrop(file, fileList);
              case 5:
                result = _context4.sent;
                if (!(result === false)) {
                  _context4.next = 8;
                  break;
                }
                return _context4.abrupt("return", runBeforeUpload({
                  beforeUpload: beforeUpload,
                  file: file,
                  resolve: _resolve,
                  reject: _reject
                }));
              case 8:
                if (result !== true) {
                  processedFile = result || file; // will open modal
                }
                _context4.next = 14;
                break;
              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](2);
                return _context4.abrupt("return", runBeforeUpload({
                  beforeUpload: beforeUpload,
                  file: file,
                  resolve: _resolve,
                  reject: _reject
                }));
              case 14:
                // read file
                reader = new FileReader();
                reader.addEventListener('load', function () {
                  if (typeof reader.result === 'string') {
                    setModalImage(reader.result); // open modal
                  }
                });
                reader.readAsDataURL(processedFile);
                // on modal cancel
                onCancel.current = function () {
                  var _a, _b;
                  setModalImage('');
                  easyCropRef.current.onReset();
                  var hasResolveCalled = false;
                  (_b = (_a = cb.current).onModalCancel) === null || _b === void 0 ? void 0 : _b.call(_a, function (LIST_IGNORE) {
                    _resolve(LIST_IGNORE);
                    hasResolveCalled = true;
                  });
                  if (!hasResolveCalled) {
                    _resolve(AntUpload.LIST_IGNORE);
                  }
                };
                // on modal confirm
                onOk.current = function (event) {
                  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                    var canvas, _processedFile, type, name, uid;
                    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          setModalImage('');
                          easyCropRef.current.onReset();
                          canvas = getCropCanvas(event.target);
                          _processedFile = processedFile, type = _processedFile.type, name = _processedFile.name, uid = _processedFile.uid;
                          canvas.toBlob(function (blob) {
                            return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                              var newFile;
                              return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                                while (1) switch (_context2.prev = _context2.next) {
                                  case 0:
                                    newFile = new File([blob], name, {
                                      type: type
                                    });
                                    Object.assign(newFile, {
                                      uid: uid
                                    });
                                    runBeforeUpload({
                                      beforeUpload: beforeUpload,
                                      file: newFile,
                                      resolve: function resolve(file) {
                                        var _a, _b;
                                        _resolve(file);
                                        (_b = (_a = cb.current).onModalOk) === null || _b === void 0 ? void 0 : _b.call(_a, file);
                                      },
                                      reject: function reject(err) {
                                        var _a, _b;
                                        _reject(err);
                                        (_b = (_a = cb.current).onModalOk) === null || _b === void 0 ? void 0 : _b.call(_a, err);
                                      }
                                    });
                                  case 3:
                                  case "end":
                                    return _context2.stop();
                                }
                              }, _callee2);
                            }));
                          }, type, quality);
                        case 5:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3);
                  }));
                };
              case 19:
              case "end":
                return _context4.stop();
            }
          }, _callee4, null, [[2, 11]]);
        }));
      });
    };
  }, [getCropCanvas, quality, runBeforeUpload]);
  var getNewUpload = useCallback(function (children) {
    var upload = Array.isArray(children) ? children[0] : children;
    var _a = upload.props,
      beforeUpload = _a.beforeUpload,
      accept = _a.accept,
      restUploadProps = __rest(_a, ["beforeUpload", "accept"]);
    return Object.assign(Object.assign({}, upload), {
      props: Object.assign(Object.assign({}, restUploadProps), {
        accept: accept || 'image/*',
        beforeUpload: getNewBeforeUpload(beforeUpload)
      })
    });
  }, [getNewBeforeUpload]);
  /**
   * modal
   */
  var modalBaseProps = useMemo(function () {
    var obj = {};
    if (modalWidth !== undefined) obj.width = modalWidth;
    if (modalOk !== undefined) obj.okText = modalOk;
    if (modalCancel !== undefined) obj.cancelText = modalCancel;
    return obj;
  }, [modalCancel, modalOk, modalWidth]);
  var wrapClassName = "".concat(PREFIX, "-modal").concat(modalClassName ? " ".concat(modalClassName) : '');
  var lang = typeof window === 'undefined' ? '' : window.navigator.language;
  var isCN = lang === 'zh-CN';
  var title = modalTitle || (isCN ? '编辑图片' : 'Edit image');
  var resetBtnText = resetText || (isCN ? '重置' : 'Reset');
  return jsxs(Fragment, {
    children: [getNewUpload(children), modalImage && jsx(AntModal, Object.assign({}, modalProps, modalBaseProps, {
      open: true,
      title: title,
      onCancel: onCancel.current,
      onOk: onOk.current,
      wrapClassName: wrapClassName,
      maskClosable: false,
      destroyOnClose: true,
      children: jsx(EasyCrop$1, {
        ref: easyCropRef,
        cropperRef: cropperRef,
        zoomSlider: zoomSlider,
        rotationSlider: rotationSlider,
        aspectSlider: aspectSlider,
        showReset: showReset,
        resetBtnText: resetBtnText,
        modalImage: modalImage,
        aspect: aspect,
        minZoom: minZoom,
        maxZoom: maxZoom,
        minAspect: minAspect,
        maxAspect: maxAspect,
        cropShape: cropShape,
        showGrid: showGrid,
        cropperProps: cropperProps
      })
    }))]
  });
});
export { ImgCrop as default };